/**
 * Badge component for displaying compliance actions with color coding
 */

import React from 'react';

type Action = 'ALLOW' | 'WARN' | 'AMEND' | 'BLOCK';

interface ActionBadgeProps {
  action: Action;
  size?: 'sm' | 'md';
  className?: string;
}

export const ActionBadge: React.FC<ActionBadgeProps> = ({ action, size = 'md', className = '' }) => {
  const sizeClasses = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-3 py-1';

  const getActionStyles = () => {
    switch (action) {
      case 'ALLOW':
        return {
          bg: 'bg-green-100 dark:bg-green-900/30',
          text: 'text-green-700 dark:text-green-300',
          border: 'border-green-300 dark:border-green-700',
          icon: '✅',
        };
      case 'WARN':
        return {
          bg: 'bg-yellow-100 dark:bg-yellow-900/30',
          text: 'text-yellow-700 dark:text-yellow-300',
          border: 'border-yellow-300 dark:border-yellow-700',
          icon: '⚠️',
        };
      case 'AMEND':
        return {
          bg: 'bg-orange-100 dark:bg-orange-900/30',
          text: 'text-orange-700 dark:text-orange-300',
          border: 'border-orange-300 dark:border-orange-700',
          icon: '✏️',
        };
      case 'BLOCK':
        return {
          bg: 'bg-red-100 dark:bg-red-900/30',
          text: 'text-red-700 dark:text-red-300',
          border: 'border-red-300 dark:border-red-700',
          icon: '🚫',
        };
      default:
        return {
          bg: 'bg-gray-100 dark:bg-gray-900/30',
          text: 'text-gray-700 dark:text-gray-300',
          border: 'border-gray-300 dark:border-gray-700',
          icon: '',
        };
    }
  };

  const styles = getActionStyles();

  return (
    <span
      className={`inline-flex items-center gap-1 ${sizeClasses} ${styles.bg} ${styles.text} ${styles.border} border rounded-full font-semibold ${className}`}
    >
      <span>{styles.icon}</span>
      <span className="capitalize">{action.toLowerCase()}</span>
    </span>
  );
};
